import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5a3112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RelatedProcessing" }
const _hoisted_2 = { class: "listItem" }
const _hoisted_3 = { class: "tag" }
const _hoisted_4 = { class: "titleWarpper" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanList, {
      class: "list",
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      onLoad: $setup.getList,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/jiaobiao.png"),
                width: "34"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.profile), 1)
            ]),
            _createElementVNode("div", _hoisted_6, "用苗地区: " + _toDisplayString(item.address), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.moment(Number(item.createTime)).fromNow()), 1),
              _createVNode(_component_VanButton, {
                size: "small",
                color: "#FFCC32",
                onClick: ($event: any) => ($setup.router.push({name:"DealWithDetail",query:{id:item.id}}))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["loading", "finished"])
  ]))
}